import React from 'react'
import Kpippmreport from '../../components/kpippmreportcomponents/Kpippmreport'

function  Kpireport({renderPageContent}) {
    return (
        <>
                        <Kpippmreport renderPageContent={renderPageContent}/>
        </>
    )
}

export default  Kpireport